<div *transloco="let t">
	<ng-container>
		<div class="px-12 flex flex-col">
			<div class="pt-6 pb-3 title">
				{{ t('userProfile.resetPassword') }}
			</div>
		</div>
		<div class=" px-12 flex flex-wrap flex-row {{ isMobile() ? 'w-full' : 'w-2/3' }}">
			<div class="m-1"></div>
			<div class="m-1"></div>
			<div class="m-1"></div>
		</div>
		<div class="px-12 flex flex-row justify-end items-center">
			<div>
				<ara-spinner-button
					[action]="sendUpdatePasswordMail.bind(this)"
					[hideTextOnMobile]="true"
					[disabledWhenSpinning]="true"
					[showSpinner]="waitingForMailToBeSent()"
					[svgIcon]="icons.get('mailAsterisk')"
					[buttonText]="t('userProfile.resetPassword')"
					[toolTip]="t('userProfile.sendUpdatePasswordMailTooltip')"></ara-spinner-button>
			</div>
		</div>
	</ng-container>
</div>
